module.exports = __webpack_public_path__ + "static/media/BoxPlotQ7_4.719eed9a.svg";